import React, { useState } from 'react';
import ModalComponent from '../../../../../common-components/ModalComponent/ModalComponent';
import { useFormValidation } from '../../../../../../hooks/useFormValidation';
import { CreateNewLabelValidation } from './validation';
import { useDispatch } from 'react-redux';
import { fetchPostTrackingLabels } from '../../../../../../redux/socialListening/socialListeningActions';
import { NotificationManager } from 'react-notifications';
import { editLabel as editLabelMutation } from '../../../../../../services/postTracking.service';
import { ChevronLeftIcon } from '../../../../../Icons';
import InputComponent from '../../../../../common-components/InputComponent/InputComponent';
import ColorSelector from './ColorSelector';
import ButtonComponent from '../../../../../common-components/ButtonComponent/ButtonComponent';
import '../../../styles/labelling.scss';

const EditLabelModal = ({ show, onClose, setActiveModal, editLabel }) => {
  const [formValues, setFormValues] = useState({ selectedColor: editLabel.color, name: editLabel.title });
  const [isLoading, setLoading] = useState(false);
  const { errors, validate, setErrors } = useFormValidation(CreateNewLabelValidation);
  const isValid = formValues.name.length > 0 && Boolean(formValues.selectedColor);
  const dispatch = useDispatch();

  const onFormSubmit = async (e) => {
    e.preventDefault();
    const isValid = validate(formValues);
    if (!isValid) return;
    setLoading(true);
    const response = await editLabelMutation({
      title: formValues.name,
      color: formValues.selectedColor,
      labelId: editLabel._id,
    });
    setLoading(false);
    if (response?.status) {
      dispatch(fetchPostTrackingLabels());
      setActiveModal('addLabel');
      NotificationManager.success('Changes Saved', '', 1200);
    } else {
      NotificationManager.error(response?.data?.message || 'Error editing label', '', 1200);
    }
  };

  return (
    <ModalComponent show={show} onClose={() => onClose()} width={450} style={{ padding: 0 }}>
      <form onSubmit={onFormSubmit}>
        <div className="sl-edit-label-container">
          <div className="sl-edit-label-header ">
            <ChevronLeftIcon
              style={{ position: 'absolute', left: '20px', cursor: 'pointer' }}
              color="var(--text-default)"
              onClick={() => setActiveModal('addLabel')}
            />
            <div className="sl-edit-label-header-title">Edit Label</div>
          </div>
          <div className="sl-edit-label-form-container ">
            <InputComponent
              value={formValues.name}
              setValue={(v) => {
                setErrors({});
                setFormValues((values) => ({ ...values, name: v }));
              }}
              placeholder="Enter Label Name"
              label="Label Name"
              labelRight={
                <span className="sl-edit-label-name-left-section">{formValues.name.length}/20 Characters</span>
              }
              error={errors.name}
            />
            <ColorSelector
              selectedColor={formValues.selectedColor}
              setSelectedColor={(c) => setFormValues((e) => ({ ...e, selectedColor: c }))}
            />
          </div>
          <div className="sl-edit-label-bottom-container">
            <ButtonComponent
              onClick={() => setActiveModal('deleteLabel')}
              style={{ flex: 1 }}
              variant="secondary-danger">
              Delete Label
            </ButtonComponent>
            <ButtonComponent disabled={!isValid} type="submit" showLoading={isLoading} style={{ flex: 1 }}>
              Save
            </ButtonComponent>
          </div>
        </div>
      </form>
    </ModalComponent>
  );
};

export default EditLabelModal;
